import React from "react";
import { H3 } from "../../../../designSystem/typography/Heading";
import styled from "styled-components";
import { rawColors, colors } from "../../../../designSystem/colors/color";

export function SurveyStyledList(
    props:{
        items:{ header: string, text: string }[]
    }
): JSX.Element {
    return (
        <StyledList>
            {props.items.map((item, index) => (
                <li key={index}>
                    <H3>{item.header}</H3>
                    {item.text}
                </li>
            ))}
        </StyledList>
    );
}

const StyledList = styled.ol`
    counter-reset: survey-step;
    display: grid;
    gap: 12px;
    list-style: none;
    margin: 20px 0 16px;
    padding: 0;

    li {
        counter-increment: survey-step;
        position: relative;
        padding: 18px 20px 18px 68px;
        /* border-left: 4px solid ${rawColors.blue.normal}; */
        border: 1px solid ${colors.card.outlined.default.border};
        border-radius: 4px;
        /* background: ${rawColors.blue.lightExtreme}; */
        color: ${colors.text.normal};
        line-height: 1.55;
    }

    li::before {
        content: counter(survey-step, decimal-leading-zero);
        position: absolute;
        top: 18px;
        left: 18px;
        display: grid;
        width: 32px;
        height: 32px;
        place-items: center;
        border-radius: 50%;
        background: ${rawColors.blue.dark};
        color: ${rawColors.white};
        font-size: 0.8rem;
        font-weight: 700;
        letter-spacing: 0.04em;
    }

    h3 {
        margin: 0 0 6px;
        color: ${rawColors.blue.dark};
    }
`;